import React from 'react'
import { RootState } from 'App'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { useFeatureFlag } from 'hooks/userFeatureFlag'
import { AppHeader } from 'components/AppDataReport/AppHeader/AppHeader.component'
import { AppGiveConsentToAdvisor } from 'components/AppDataReport/AppGiveConsentToAdvisor/AppGiveConsentToAdvisor.component'
import {
  AppButtonTabsV2,
  AppTab,
} from 'components/Common/AppButtonTabsV2/AppButtonTabsv2.component'
import { AppPlaceholderArt } from 'components/AppDataReport/AppData/AppPlaceholderArt/AppPlaceholderArt.component'
import { getRoleFromPath, navigateTo, replaceTerm } from 'utils/helper'
import { AppOverView } from 'components/AppDataReport/AppData/AppOverview/AppOverview.component'
import { AppProduct } from 'components/AppDataReport/AppData/AppProduct/AppProduct.component'
import { AppFinanceContainer } from 'components/AppDataReport/AppDataReport.container'

export const AppDataReport = () => {
  let { subTab } = useParams()

  const { user } = useSelector((state: RootState) => state.user)
  const dataChartsEnabled = useFeatureFlag(user?.id, 'release-data-charts')
  const dataTabDisabled = useFeatureFlag(user?.id, 'release-data-tab')

  const bsoProfile = useSelector((state: RootState) => state.bso.bsoProfile)
  const advisorTerm = replaceTerm('advisor', bsoProfile.terminology).toLowerCase()

  /** This is fallback content while feature is being built */

  const userRole = getRoleFromPath()
  const changeTabHandler = (activeTab: string) => {
    navigateTo(userRole, `data-charts/${activeTab}`)
  }

  if (!dataTabDisabled) {
    return <AppDataInsightsPrototype />
  }

  return (
    <>
      {dataChartsEnabled ? (
        <div className="w-full">
          <div className="pb-14">
            <AppHeader />
            <AppGiveConsentToAdvisor />
          </div>

          <AppButtonTabsV2 activeTab={subTab} onChange={changeTabHandler} classes="bg-white">
            <AppTab title="Overview" name="overview" component={<AppOverView />} />
            <AppTab title="Data" name="data" component={<AppFinanceContainer />} />
            <AppTab title="Finance" name="finance" component={<AppProduct />} />
          </AppButtonTabsV2>
        </div>
      ) : (
        <div className="w-full flex justify-center p-4 max-w-[545px]">
          <div className="flex flex-col text-center gap-4 sm:gap-6">
            <h1 className="text-[40px] font-secondary leading-10">Your data is on the way</h1>
            <p>
              As we get to know your business, GoTackle will deliver actionable data to this screen
              (and to your {advisorTerm}) to help you achieve your business goals.
            </p>
            <div className="">
              <AppPlaceholderArt />
            </div>
          </div>
          <div></div>
        </div>
      )}
    </>
  )
}

export const AppDataInsightsPrototype = () => {
  const prototypeUrl = 'https://v0-insights-inky.vercel.app/dashboard/max-candle/insights'
  // data tab
  return (
    <div className="w-full">
      <iframe
        id="dashboard-iframe"
        src={prototypeUrl}
        className="w-full h-[800px] border-none"
        allowFullScreen
        title="RevNation Dashboard"
      />
    </div>
  )
}
